import React, { useState } from 'react';
import ParallaxImage from './ParallaxImage';
import GreenButton from './GreenButton';
import ShowroomModal from './ShowroomModal';

/** Showroom band: photo, headline, green scribble and a visit CTA. */
const TeamBand: React.FC = () => {
  const [showroomOpen, setShowroomOpen] = useState(false);

  return (
    <>
      <ParallaxImage
        src="/home/showroom.jpg"
        overlay="rgba(0,0,0,0.5)"
        className="min-h-[480px] md:min-h-[600px] flex items-center justify-center text-white px-6"
        style={{ clipPath: 'polygon(0 0, 100% 6%, 100% 94%, 0 100%)' }}
      >
        <div className="text-center max-w-4xl mx-auto py-20">
          <h2 className="font-montserrat font-extrabold tracking-[-0.03em] leading-[1.05] text-[clamp(30px,4.5vw,64px)]">
            Over 200 garments, signage and print samples to browse in our Showroom
          </h2>
          <img
            src="/home/scribble-green.png"
            alt=""
            aria-hidden="true"
            className="mx-auto mt-5 w-40 md:w-56 h-auto"
            loading="lazy"
          />
          <div className="mt-8">
            <GreenButton onClick={() => setShowroomOpen(true)}>Visit our showroom</GreenButton>
          </div>
        </div>
      </ParallaxImage>
      <ShowroomModal isOpen={showroomOpen} onClose={() => setShowroomOpen(false)} />
    </>
  );
};

export default TeamBand;
